import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ViaCepResponse {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string; // cidade
  uf: string; // estado
  ibge?: string;
  gia?: string;
  ddd?: string;
  siafi?: string;
  erro?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ViaCepService {
  constructor(private http: HttpClient) {}

  lookup(cep: string): Observable<ViaCepResponse> {
    const digits = (cep || '').replace(/\D+/g, '').slice(0, 8);
    return this.http.get<ViaCepResponse>(`https://viacep.com.br/ws/${digits}/json/`);
  }
}